import Slide, { SlideProps } from '@material-ui/core/Slide';
import * as React from 'react';

/**
 * 上向きにSlideするTransition
 * @param props
 */
export const UpwardTransition: React.FC<
	Partial<Omit<SlideProps, 'direction'>>
> = props => {
	return <Slide direction="up" {...props} />;
};



// WEBPACK FOOTER //
// ./src/utils/Transition.tsx